module.exports = __webpack_public_path__ + "img/shangye_shanxishengwei_suoluetu.4d0c521c.png";